
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import logo from "../assets/jivilogo.png";
import down from "../assets/Down.svg";
import nr from "../assets/Nr.png";

import icon1 from "../assets/icon1.png";
import icon1Hover from "../assets/icon1-hover.png";
import icon2 from "../assets/icon2.png";
import icon2Hover from "../assets/icon2-hover.png";
import icon3 from "../assets/icon3.png";
import icon3Hover from "../assets/icon3-hover.png";
import icon4 from "../assets/icon4.png";
import icon4Hover from "../assets/icon4-hover.png";
import icon5 from "../assets/icon5.png";
import icon5Hover from "../assets/icon5-hover.png";
import icon6 from "../assets/icon6.png";
import icon6Hover from "../assets/icon6-hover.png";
import icon7 from "../assets/icon7.png";

export default function Header() {
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileProducts, setShowMobileProducts] = useState(false);
  const [activeItem, setActiveItem] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);


  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveItem("Home");
    else if (path === "/about") setActiveItem("About Us");
    else if (path === "/schedule-a-demo") setActiveItem("Schedule a Demo");
    else if (path === "/support") setActiveItem("Support");
    else if (
      [
        "/workforce-scheduler",
        "/automated-work-allocation-assignment",
        "/operational-workload-planning",
        "/employee-self-service",
        "/capacity-planning",
        "/time-attendance",
        "/connected-systems",
      ].includes(path)
    ) {
      setActiveItem("Products");
    } else {
      setActiveItem("");
    }
  }, [location.pathname]);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest("[data-products-button]")
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClick = (item) => {
    setActiveItem(item);
    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
      if (item === "Home") navigate("/");
      else if (item === "About Us") navigate("/about");
      else if (item === "Schedule a Demo") navigate("/schedule-a-demo");
      else if (item === "Support")
        window.open(
          "https://jivisolutions.atlassian.net/servicedesk/customer/portals",
          "_blank",
          "noopener,noreferrer"
        );
    }
  };

  const menuItemStyle = {
    padding: "12px 0",
    color: "#FFFFFF",
    fontSize: "15px",
    borderBottom: "1px solid rgba(255,255,255,0.15)",
    cursor: "pointer",
    transition: "background 0.3s",
  };

  const dropdownItems = [
    {
      items: [
        {
          name: "Workforce Scheduler",
          description:
            "Schedules resources efficiently for maximum workforce productivity.",
          icon: icon1,
          iconHover: icon1Hover,
          path: "/workforce-scheduler",
        },
        {
          name: "Automated Work Allocation & Assignment",
          description: "Automatically assigns manpower based on defined rules.",
          icon: icon4,
          iconHover: icon4Hover,
          path: "/automated-work-allocation-assignment",
        },
        {
          name: "Connected Systems",
          description: "Integration with Port Terminal Operation Platforms.",
          icon: icon7,
          iconHover: icon4Hover,
          path: "/connected-systems",
        },
      ],
    },
    {
      items: [
        {
          name: "Operational Workload Planning",
          description:
            "Schedules vessel, equipment, and labor efficiently via TOS.",
          icon: icon2,
          iconHover: icon2Hover,
          path: "/operational-workload-planning",
        },
        {
          name: "Employee Self Service",
          description: "Employees manage leave, schedules, and work online.",
          icon: icon5,
          iconHover: icon5Hover,
          path: "/employee-self-service",
        },
      ],
    },
    {
      items: [
        {
          name: "Capacity Planning",
          description:
            "Addresses pre- and post-shift changes accurately, timely.",
          icon: icon3,
          iconHover: icon3Hover,
          path: "/capacity-planning",
        },
        {
          name: "Time & Attendance",
          description: "Manages employee attendance via time clock interface.",
          icon: icon6,
          iconHover: icon6Hover,
          path: "/time-attendance",
        },
      ],
    },
  ];

  return (
    <>

      <header
        style={{
          fontFamily: "Epilogue, sans-serif",
          height: "70px",
          top: 0,
          zIndex: 1000,
          display: "flex",
          position: "sticky",
          justifyContent: "space-between",
          alignItems: "center",
          padding: isMobile ? "10px 5%" : "0px 6%",
          backgroundColor: "#1E72BB",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
        }}
      >

        <Link
          to="/"
          onClick={() => {
            setActiveItem("Home");
            setShowDropdown(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              maxWidth: isMobile ? "130px" : "160px",
              height: "auto",
            }}
          />
        </Link>

        {!isMobile && (
          <nav
            style={{
              display: "flex",
              alignItems: "center",
              gap: "22px",
            }}
          >
            {["Home", "About Us", "Products", "Schedule a Demo", "Support"].map((item, index) => (
              <div key={index}>
                <div
                  data-products-button={item === "Products" ? "true" : undefined}
                  onClick={() => handleClick(item)}
                  style={{
                    fontSize: "15px",
                    cursor: "pointer",
                    fontWeight: activeItem === item ? "700" : "500",
                    color: activeItem === item ? "#1E72BB" : "#FFFFFF",
                    backgroundColor: activeItem === item ? "#FFFFFF" : "transparent",
                    padding: "8px 18px",
                    borderRadius: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "color 0.2s ease",
                  }}
                >
                  {item}

                  {item === "Products" && (
                    <img
                      src={down}
                      alt="Down Arrow"
                      style={{
                        width: "10px",
                        height: "7px",
                        filter: activeItem === "Products" ? "invert(0%)" : "invert(100%)",
                        transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease, filter 0.3s ease",
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </nav>
        )}

        {isMobile && (
          <button
            onClick={() => {
              const newState = !isMobileMenuOpen;
              setIsMobileMenuOpen(newState);
              if (!newState) setShowMobileProducts(false);
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "6px",
            }}
            aria-label="Toggle menu"
          >
            <svg
              width="28"
              height="28"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        )}
      </header>

      {isMobile && isMobileMenuOpen && (
        <nav
          onClick={() => setIsMobileMenuOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "#1E72BB",
            zIndex: 1050,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            paddingTop: "80px",
            overflowY: "auto",
            animation: "fadeDown 0.3s ease",
          }}
        >
          <ul
            style={{
              listStyle: "none",
              margin: 0,
              padding: "10px 0",
              width: "100%",
              textAlign: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <li
              style={{
                ...menuItemStyle,
                background: activeItem === "Home" ? "#FFFFFF" : "transparent",
                color: activeItem === "Home" ? "#1E72BB" : "#FFFFFF",
                fontWeight: activeItem === "Home" ? "600" : "400",
              }}
              onClick={() => {
                navigate("/");
                setActiveItem("Home");
                setIsMobileMenuOpen(false);
                setShowMobileProducts(false);
              }}
            >
              Home
            </li>
            <li
              style={{
                ...menuItemStyle,
                background: activeItem === "About Us" ? "#FFFFFF" : "transparent",
                color: activeItem === "About Us" ? "#1E72BB" : "#FFFFFF",
                fontWeight: activeItem === "About Us" ? "600" : "400",
              }}
              onClick={() => {
                navigate("/about");
                setActiveItem("About Us");
                setIsMobileMenuOpen(false);
                setShowMobileProducts(false);
              }}
            >
              About Us
            </li>
            <li
              style={menuItemStyle}
              onClick={() => setShowMobileProducts(!showMobileProducts)}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                Products
                <img
                  src={down}
                  alt="Arrow"
                  style={{
                    width: 10,
                    height: 7,
                    transform: showMobileProducts ? "rotate(180deg)" : "rotate(0)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </li>
            {showMobileProducts &&
              dropdownItems.flatMap((section) =>
                section.items.map((product, i) => {
                  const isActiveProduct = location.pathname === product.path;
                  return (
                    <li
                      key={i}
                      style={{
                        ...menuItemStyle,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 8,
                        background: isActiveProduct ? "#FFFFFF" : "#155A97",
                        color: isActiveProduct ? "#1E72BB" : "#FFFFFF",
                        fontWeight: isActiveProduct ? "600" : "400",
                        fontSize: "14px",
                        padding: "10px 0",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => {
                        navigate(product.path);
                        setIsMobileMenuOpen(false);
                        setShowMobileProducts(false);
                      }}
                    >

                      {product.name}
                    </li>
                  );
                })
              )}
            <li
              style={{
                ...menuItemStyle,
                background: activeItem === "Schedule a Demo" ? "#FFFFFF" : "transparent",
                color: activeItem === "Schedule a Demo" ? "#1E72BB" : "#FFFFFF",
                fontWeight: activeItem === "Schedule a Demo" ? "600" : "400",
              }}
              onClick={() => {
                navigate("/schedule-a-demo");
                setActiveItem("Schedule a Demo");
                setIsMobileMenuOpen(false);
                setShowMobileProducts(false);
              }}
            >
              Schedule a Demo
            </li>
            <li
              style={{
                ...menuItemStyle,
                background: activeItem === "Support" ? "#FFFFFF" : "transparent",
                color: activeItem === "Support" ? "#1E72BB" : "#FFFFFF",
                fontWeight: activeItem === "Support" ? "600" : "400",
              }}
              onClick={() => {
                window.open(
                  "https://support.jivisolutions.com",
                  "_blank",
                  "noopener,noreferrer"
                );
                setActiveItem("Support");
                setIsMobileMenuOpen(false);
                setShowMobileProducts(false);
              }}
            >
              Support
            </li>

          </ul>
        </nav>
      )}

      {!isMobile && showDropdown && (
        <div
          ref={dropdownRef}
          style={{
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            backgroundColor: "#FFFFFF",
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            borderRadius: "24px",
            width: "min(1180px, 120vw)",
            padding: "24px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "20px",
          }}
        >
          {dropdownItems.map((section, i) => (
            <div
              key={i}
              style={{
                paddingRight: i < dropdownItems.length - 1 ? "16px" : undefined,
                borderRight:
                  i < dropdownItems.length - 1 ? "1px solid #E0E0E0" : "none",
              }}
            >
              {section.items.map((product, j) => {
                const isActiveProduct = location.pathname === product.path;
                const isHovered = hoveredProduct === product.path;


                const highlightColor = "#E0F3FF";

                const bgColor = isActiveProduct || isHovered ? highlightColor : "transparent";
                const textColor = isActiveProduct || isHovered ? "#000000" : "#000000";
                const descColor = isActiveProduct || isHovered ? "#333333" : "#666666";

                return (
                  <div
                    key={j}
                    onClick={() => {
                      setShowDropdown(false);
                      navigate(product.path);
                    }}
                    onMouseEnter={() => setHoveredProduct(product.path)}
                    onMouseLeave={() => setHoveredProduct(null)}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 10,
                      padding: "10px",
                      cursor: "pointer",
                      borderRadius: 8,
                      backgroundColor: bgColor,
                      transform: isActiveProduct || isHovered ? "scale(1.03)" : "scale(1)",
                      transition: "all 0.25s ease",
                      boxShadow:
                        isActiveProduct || isHovered
                          ? "0 6px 18px rgba(0,0,0,0.1)"
                          : "none",
                    }}
                  >

                    <img
                      src={product.icon}
                      alt={product.name}
                      style={{
                        width: 45,
                        height: 45,
                        objectFit: "contain",
                        transition: "transform 0.25s ease",
                        transform: isActiveProduct || isHovered ? "scale(1.05)" : "scale(1)",
                      }}
                    />


                    <div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          fontWeight: 600,
                          fontSize: 16,
                          color: textColor,
                          marginBottom: 2,
                          flexWrap: "nowrap",
                          transition: "color 0.25s ease",
                        }}
                      >
                        <span>{product.name}</span>
                        <img
                          src={nr}
                          alt="arrow"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "contain",
                            transform: isHovered
                              ? "translateY(1px) translateX(4px)"
                              : "translateY(1px)",
                            transition: "transform 0.3s ease",
                            filter: "brightness(0) invert(0.4)",
                          }}
                        />
                      </div>


                      <div
                        style={{
                          color: descColor,
                          fontSize: 15,
                          lineHeight: 1.4,
                          transition: "color 0.25s ease",
                        }}
                      >
                        {product.description}
                      </div>
                    </div>
                  </div>
                );
              })}

            </div>
          ))}
        </div>
      )}



      <style>{`
    @keyframes fadeDown {
      from { opacity: 0; transform: translateY(-10px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `}</style>
    </>

  );
}
